import i18n from "@/i18n";
const routes = {
  path: "/fitting",
  name: "Fitting",
  component: () =>
    import(/* webpackChunkName: "fitting" */ "@/views/fitting/Main"),
  children: [
    {
      path: "fittinglist",
      alias: "",
      name: "FittingList",
      component: () =>
        import(/* webpackChunkName: "fitting" */ "@/views/fitting/FittingList"),
      prop: true,
      meta: {
        location: "/fitting/fittinglist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("menu.brandroom.fitting"),
        step: [
          i18n.t("menu.brandroom.fitting_management"),
          i18n.t("menu.brandroom.fitting"),
        ],
        menu_num: 7,
        sub_menu_num: 71,
      },
    },
    {
      path: "fittingswinglist/:fittingno",
      name: "FittingSwingList",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/fitting/FittingSwingList"
        ),
      prop: true,
      meta: {
        location: "/fitting/fittinglist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("menu.brandroom.fitting_swing_list"),
        step: [
          i18n.t("menu.brandroom.fitting_management"),
          i18n.t("menu.brandroom.fitting"),
        ],
        menu_num: 7,
        sub_menu_num: 71,
      },
    },
    {
      path: "fittinganswerview/:fitreqno",
      name: "FittingAnswerView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/fitting/FittingAnswerView"
        ),
      prop: true,
      meta: {
        location: "/fitting/fittinglist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("title.fitting.fitting_details"),
        menu_num: 7,
        sub_menu_num: 71,
        step: [
          i18n.t("menu.brandroom.fitting_management"),
          i18n.t("menu.brandroom.fitting"),
        ],
      },
    },
    {
      path: "salelist",
      alias: "",
      name: "SaleList",
      component: () =>
        import(/* webpackChunkName: "fitting" */ "@/views/fitting/SaleList"),
      prop: true,
      meta: {
        location: "/fitting/salelist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("menu.brandroom.sales"),
        step: [
          i18n.t("menu.brandroom.fitting_management"),
          i18n.t("menu.brandroom.sales"),
        ],
        menu_num: 7,
        sub_menu_num: 72,
      },
    },
    {
      path: "saleview/:fitansno",
      name: "SaleView",
      component: () =>
        import(/* webpackChunkName: "tournament" */ "@/views/fitting/SaleView"),
      prop: true,
      meta: {
        location: "/fitting/salelist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.brandroom.sales_view"),
        menu_num: 7,
        sub_menu_num: 72,
        step: [
          i18n.t("menu.brandroom.fitting_management"),
          i18n.t("menu.brandroom.sales"),
        ],
      },
    },

    {
      path: "customerlist",
      alias: "",
      name: "CustomerList",
      category: 0,
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/fitting/CustomerList"
        ),
      prop: true,
      meta: {
        location: "/fitting/customerlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("menu.brandroom.cs_center"),
        menu_num: 7,
        sub_menu_num: 73,
        step: [
          i18n.t("menu.brandroom.fitting_management"),
          i18n.t("menu.brandroom.cs_center"),
        ],
      },
    },
    {
      path: "customerview/:noticeno",
      name: "CustomerView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/fitting/CustomerView"
        ),
      prop: true,
      meta: {
        location: "/fitting/customerlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("menu.brandroom.view_details"),
        menu_num: 7,
        sub_menu_num: 73,
        step: [
          i18n.t("menu.brandroom.fitting_management"),
          i18n.t("menu.brandroom.cs_center"),
        ],
      },
    },
    {
      path: "customerwrite/:noticeno?",
      name: "CustomerWrite",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/fitting/CustomerWrite"
        ),
      prop: true,
      meta: {
        location: "/fitting/customerlist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.brandroom.as_write"),
        menu_num: 7,
        sub_menu_num: 73,
        step: [
          i18n.t("menu.brandroom.fitting_management"),
          i18n.t("menu.brandroom.cs_center"),
        ],
      },
    },
  ],
};

export default routes;
